import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';



const RadarChartSimple = ({data}) => {
  

  const getIntroOfPage = (label) => {
  if (label === 'Identity') {
    return (
      <div>
      <ul>
      <li>Total score is {data[0].B} out of 28</li>
      <li>Traditional = {data[0].C}</li>
      <li>Initial = {data[0].D}</li>
      <li>Advanced = {data[0].E}</li>
      <li>Optimal = {data[0].F}</li>
      </ul>

      <p style={{padding:'0.5em'}}>Average of all users is {data[0].allUserAverage}</p>
      </div>
    );
  }
  if (label === 'Devices') {
    return (
      <div>
      <ul>
      <li>Total score is {data[1].B} out of 28</li>
      <li>Traditional = {data[1].C}</li>
      <li>Initial = {data[1].D}</li>
      <li>Advanced = {data[1].E}</li>
      <li>Optimal = {data[1].F}</li>
      </ul>

      <p style={{padding:'0.5em'}}>Average of all users is {data[1].allUserAverage}</p>
      </div>
    )
  }
  if (label === 'Networks') {
    return (
      <div>
      <ul>
      <li>Total score is {data[2].B} out of 28</li>
      <li>Traditional = {data[2].C}</li>
      <li>Initial = {data[2].D}</li>
      <li>Advanced = {data[2].E}</li>
      <li>Optimal = {data[2].F}</li>
      </ul>

         <p style={{padding:'0.5em'}}>Average of all users is {data[2].allUserAverage}</p>
      </div>
    )
  }
  if (label === 'Applications & Workloads') {
    return (
      <div>
      <ul>
      <li>Total score is {data[3].B} out of 32</li>
      <li>Traditional = {data[3].C}</li>
      <li>Initial = {data[3].D}</li>
      <li>Advanced = {data[3].E}</li>
      <li>Optimal = {data[3].F}</li>
      </ul>

         <p style={{padding:'0.5em'}}>Average of all users is {data[3].allUserAverage}</p>
      </div>
    )
  }
  if (label === 'Data') {
    return (
      <div>
      <ul>
      <li>Total score is {data[4].B} out of 32</li>
      <li>Traditional = {data[4].C}</li>
      <li>Initial = {data[4].D}</li>
      <li>Advanced = {data[4].E}</li>
      <li>Optimal = {data[4].F}</li>
      </ul>

         <p style={{padding:'0.5em'}}>Average of all users is {data[4].allUserAverage}</p>
      </div>
    )
    
  }
  if (label === 'Cross-Cutting') {
    return (
      <div>
      <ul>
      <li>Total score is {data[5].B} out of 12</li>
      <li>Traditional = {data[5].C}</li>
      <li>Initial = {data[5].D}</li>
      <li>Advanced = {data[5].E}</li>
      <li>Optimal = {data[5].F}</li>
      </ul>

         <p style={{padding:'0.5em'}}>Average of all users is {data[5].allUserAverage}</p>
      </div>
    )
    
  }
  return '';
};


  const CustomTooltip = ({ active, payload, label }) => {
  const isVisible = active && payload && payload.length;
  return (
    <div className="custom-tooltip" style={{ visibility: isVisible ? 'visible' : 'hidden', backgroundColor: 'gray', }}>
      {isVisible && (
        <>
          <p className="label" style={{padding:'0.5em'}}>{`${label} : ${payload[0].value.toFixed(2)}`}</p>
          <p className="intro">{getIntroOfPage(label)}</p>
          <p className="desc">Anything you want can be displayed here.</p>
        </>
      )}
    </div>
  );
};


  return (
      <ResponsiveContainer width="100%" height={400}>
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
          <PolarGrid />
          <PolarAngleAxis dataKey="subject" />
          {/* <PolarRadiusAxis domain={domain}/> */}
          <PolarRadiusAxis domain={[0, 1]}/>
          <Tooltip content={CustomTooltip} isAnimationActive={true} />
          <Legend />
          <Radar name="Your Answers" dataKey="A" stroke="#8884d8" fill="#8884d8" fillOpacity={0.6} />
          <Radar name="All User Average" dataKey="B" stroke="#99ccff" fill="#0bd9f5ff" fillOpacity={0.6} />
        </RadarChart>
      </ResponsiveContainer>
    );
};

export default RadarChartSimple;
